// tslint:disable max-line-length
import classNames from 'classnames';
import styles from './WebsiteReportSummaryVersionB.module.css';
import React from 'react';

export const Magnifier = ({
  paidTraffic,
  organicTraffic,
  className,
}: {
  paidTraffic: number;
  organicTraffic: number;
  className?: string;
}) => {
  return (
    <svg
      width="258"
      height="266"
      viewBox="0 0 258 266"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_i_2441_43475)">
        <ellipse
          cx="92"
          cy="88"
          rx="92"
          ry="88"
          fill="url(#paint0_radial_2441_43475)"
          fillOpacity="0.97"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M146.67 160.685L160.707 146.684L193.008 181.982L178.971 195.984L146.67 160.685Z"
        fill="url(#paint1_linear_2441_43475)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M171.498 189.646C176.412 183.894 181.429 178.491 186.829 174.356C187.911 173.529 187.821 171.756 186.88 170.725L184.073 167.658C183.624 167.165 183.007 166.877 182.356 166.856C181.705 166.835 181.073 167.083 180.595 167.546C175.124 172.915 169.921 177.937 165.265 182.836C164.321 183.83 164.273 185.436 165.216 186.467L168.021 189.533C168.963 190.562 170.606 190.692 171.498 189.646Z"
        fill="url(#paint2_linear_2441_43475)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M169.3 188.412C176.71 181.015 179.061 177.38 185.626 171.674C185.981 171.32 186.456 171.127 186.947 171.137C187.438 171.146 187.905 171.358 188.247 171.726L257.313 244.965C258.013 245.728 257.856 246.846 257.243 247.7C251.354 255.921 248.851 259.894 239.967 264.84C239.066 265.341 238.048 265.555 237.347 264.788L169.22 191.549C168.52 190.783 168.561 189.149 169.3 188.412Z"
        fill="url(#paint3_linear_2441_43475)"
      />
      <defs>
        <filter
          id="filter0_i_2441_43475"
          x="3.05176e-05"
          y="-1"
          width="184"
          height="177"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2441_43475"
          />
        </filter>
        <radialGradient
          id="paint0_radial_2441_43475"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(91.5282 67.0939) rotate(78.5603) scale(104.665 106.294)"
        >
          <stop offset="0.489583" stopColor="white" />
          <stop offset="1" stopColor="#EFF7FF" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_2441_43475"
          x1="177.305"
          y1="164.067"
          x2="161.779"
          y2="177.934"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A7AAAB" />
          <stop offset="0.213542" stopColor="#EFEEED" />
          <stop offset="0.484375" stopColor="#8B8E90" />
          <stop offset="0.82" stopColor="#5A5D5E" />
          <stop offset="1" stopColor="#A7AAAB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2441_43475"
          x1="185.726"
          y1="169.178"
          x2="165.492"
          y2="187.251"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A7AAAB" />
          <stop offset="0.223958" stopColor="#EFEEED" />
          <stop offset="0.45" stopColor="#8B8E90" />
          <stop offset="0.82" stopColor="#5A5D5E" />
          <stop offset="1" stopColor="#A7AAAB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2441_43475"
          x1="233.021"
          y1="251.22"
          x2="250.742"
          y2="234.829"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#43608A" />
          <stop offset="0.201" stopColor="#6E89AF" />
          <stop offset="0.48" stopColor="#728DB6" />
          <stop offset="1" stopColor="#43608A" />
        </linearGradient>
      </defs>
      <foreignObject x="25" y="25" width="140" height="140">
        <div
          className={classNames(styles.statistics, styles.column, styles.gap16)}
        >
          {!!organicTraffic && (
            <div className={classNames(styles.column, styles.gap4)}>
              <div>Estimated Organic Traffic</div>
              <span className={styles.stat}>
                {organicTraffic.toLocaleString('en-US')}
              </span>
            </div>
          )}
          {!!paidTraffic && (
            <div className={classNames(styles.column, styles.gap4)}>
              <div>Estimated Paid Traffic</div>
              <span className={styles.stat}>
                {paidTraffic.toLocaleString('en-US')}
              </span>
            </div>
          )}
        </div>
      </foreignObject>
    </svg>
  );
};
